import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

export const PublicRoute = ({
  isAuthenticated,
  role,
  component: Component,
  ...rest
}) => (
    <Route {...rest} component={
      (props) => {
        if (isAuthenticated) {
          if(role === 'administrator'){
            return <Redirect to="/profiles" />
          } else if(role === 'liaison'){
            return <Redirect to="/profiles" />
          } else {
            return <Redirect to="/dashboard" />
          }
        } else {
          return <Component {...props} />
        }
      }
    } />
  );

const mapStateToProps = (state) => ({
  isAuthenticated: !!state.auth.token,
  role: state.auth.role
});

export default connect(mapStateToProps)(PublicRoute);



// WEBPACK FOOTER //
// ./src/routers/PublicRoute.jsx